var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TotemSelect',{ref:"selectLevel",staticClass:"filter-select",attrs:{"options":_vm.levelOptions,"placeholder":_vm.$t('CourseListFilter.skill_level'),"isFilter":true,"reduce":option => String(option.level),"value":_vm.selectedLevel},on:{"input":_vm.selectLevel}})
}
var staticRenderFns = []

export { render, staticRenderFns }